import styles from "./styles.module.scss";

export const TicketCard = () => {
  return (
    <div className={styles.ticketcardContainer}>
      <div className={styles.issueTag}>Subscription</div>
      <div className={styles.postedAt}>Posted at 12:45 AM</div>
      <div className={styles.subject}>I am not able to capture the swings?</div>
      <div className={styles.desc}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum
        dolor sit amet, consectetur...
      </div>
    </div>
  );
};
